import * as React from 'react';
import { Options as StyledOptions, OptionItem } from './Dropdown.style';
var Options = _ref => {
  var {
    options,
    noOptionsMessage,
    onSelect,
    isVisible,
    isSearchable,
    selectedValue
  } = _ref;
  var onSelectOption = option => {
    if (!option.disabled) onSelect(option);
  };
  var canShowNotFoundMessage = isSearchable && options.length === 0;
  return /*#__PURE__*/React.createElement(StyledOptions, {
    role: "listbox",
    isVisible: isVisible
  }, canShowNotFoundMessage && /*#__PURE__*/React.createElement(OptionItem, {
    "data-testid": "option-not-found",
    key: "not-found",
    role: "option",
    isDisabled: true
  }, noOptionsMessage), options.map((option, index) => /*#__PURE__*/React.createElement(OptionItem, {
    key: index,
    role: "option",
    onClick: () => onSelectOption(option),
    isSelected: option === selectedValue,
    isDisabled: option.disabled,
    "aria-disabled": option.disabled,
    "aria-selected": option === selectedValue
  }, option.text)));
};
export { Options };
//# sourceMappingURL=Options.js.map